var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2001 3.84319C6.32787 3.41852 5.37022 3.19853 4.4001 3.19999C3.3961 3.19999 2.4457 3.43199 1.6001 3.84319V11.8432C2.47234 11.4185 3.42998 11.1986 4.4001 11.2C5.7353 11.2 6.9745 11.608 8.0001 12.308C9.06096 11.5842 10.3158 11.198 11.6001 11.2C12.6041 11.2 13.5545 11.432 14.4001 11.8432V3.84319C13.5279 3.41852 12.5702 3.19853 11.6001 3.19999C10.5961 3.19999 9.6457 3.43199 8.8001 3.84319V9.59999C8.8001 9.81216 8.71581 10.0156 8.56578 10.1657C8.41575 10.3157 8.21227 10.4 8.0001 10.4C7.78792 10.4 7.58444 10.3157 7.43441 10.1657C7.28438 10.0156 7.2001 9.81216 7.2001 9.59999V3.84319Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookOpen);
export default __webpack_public_path__ + "static/media/BookOpen.0b2aa21ab2c7eaa3dfb79931738504af.svg";
export { ForwardRef as ReactComponent };